import FormulaMode from '../../../../model/FormulaMode'

const OPERATOR_MAP = FormulaMode.OPERATOR_MAP

export default {
  name: 'BaseFormula',
  props: {
    completion: {
      required: true,
      type: Object
    },
    measureInstruments: {
      required: true,
      type: Array
    }
  },
  methods: {
    compare (val1, val2) {
      let fn = OPERATOR_MAP[this.completion.sign]
      return fn ? fn(val1, val2) : false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Data/TaskResult/Completion/BaseFormula.js